<div *ngIf="loadingInProgress$ | async" class="d-flex justify-content-center">
  <app-progress-spinner></app-progress-spinner>
</div>
<div [hidden]="loadingInProgress$ | async">
  <ng-container *transloco="let t; read: 'blocked-caller'">
    <p-toast position="bottom-center"></p-toast>

    <mat-card *ngrxLet="phoneNumberData$ | async as phoneNumberData" class="selector-card">
      <mat-card-header>
        <h2>{{ t('title') }}</h2>
      </mat-card-header>

      <mat-card-content>
        <p-messages severity="success">
          <ng-template pTemplate>{{ t('longTermBlockAnnouncement') }}</ng-template>
        </p-messages>

        <p-messages severity="info">
          <ng-template *ngIf="phoneNumberData?.isAnonymous" pTemplate>
            {{ t('anonymousCallerInfo') }}
          </ng-template>
        </p-messages>

        <form *ngIf="!loading" class="blocked-caller__form" [formGroup]="form">
          <div class="form-row">
            <div class="col">
              <!-- Reason -->
              <mat-form-field *ngrxLet="form.controls.reason as reason" class="full-width">
                <textarea
                  class="full-width"
                  formControlName="reason"
                  matInput
                  placeholder="{{ t('reason') }}"
                ></textarea>
                <mat-error *ngIf="reason.invalid && reason.touched">
                  {{ t('requiredField') }}
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col">
              <!-- Expire Time -->
              <label *ngrxLet="form.controls.expireTime as expireTime" class="blocked-caller__datetime-field">
                <span class="blocked-caller__datetime-label">{{ t('endTime') }}</span>
                <input formControlName="expireTime" pInputText type="datetime-local" />
                <app-form-field-help [control]="expireTime">
                  <ng-container form-field-help-errors>
                    <div *ngIf="expireTime.invalid">{{ t('expireTimeError') }}</div>
                  </ng-container>
                </app-form-field-help>
              </label>
            </div>
          </div>

          <p-checkbox
            *ngIf="form.controls.allowedToBlock.enabled"
            class="p-checkbox--centered"
            formControlName="allowedToBlock"
            [binary]="true"
            [label]="t('allowedToBlock', phoneNumberData)"
          >
          </p-checkbox>
        </form>
      </mat-card-content>

      <mat-card-actions>
        <button
          mat-button
          [disabled]="isBlockExpired || apiCallInProgress || form.invalid || callIsOlderThan30Days"
          (click)="doExpireNow()"
        >
          {{ t('expireCurrentBlockButtonLabel', { isBlockExpired }) }}
        </button>
        <button
          *ngIf="form.enabled"
          color="accent"
          mat-button
          [disabled]="apiCallInProgress || form.invalid || callIsOlderThan30Days"
          (click)="doBlock()"
        >
          {{ t('blockButtonLabel', phoneNumberData) }}
        </button>
      </mat-card-actions>

      <div *ngIf="callIsOlderThan30Days">
        {{ t('cannotEdit') }}
      </div>
    </mat-card>
  </ng-container>
</div>
